import PicturesApp from 'station/components/picture/PicturesApp'
import React, { useMemo } from 'react'
import { shallowEqual, useSelector } from 'react-redux'
import useTitle from 'utils/customHook/useTitle'
import i18n from 'simple-react-i18n'
import { getStationTitleWithTownName } from 'utils/StationUtils'

const PiezometryPicturesApp = ({

}) => {
    const {
        piezometer,
        piezometers,
        citiesIndex,
    } = useSelector(store => ({
        piezometer: store.StationReducer.piezometer,
        piezometers: store.PiezometryReducer.piezometersLight,
        citiesIndex: store.CityReducer.citiesIndex,
    }), shallowEqual)

    const townName = useMemo(() => citiesIndex[piezometer.townCode]?.name, [citiesIndex, piezometer])

    useTitle(() => [{
        title: i18n.piezometry,
        href: 'piezometry',
    }, {
        title: getStationTitleWithTownName(piezometer, townName),
        href: `station/piezometry/${piezometer?.id}`,
    }, {
        title: i18n.picturesAndDocuments,
        href: `station/piezometry/${piezometer?.id}/picture`,
    }], [piezometer, townName])

    return (
        <PicturesApp
            stations={piezometers}
            station={piezometer}
            stationType='piezometry'
        />
    )
}

export default PiezometryPicturesApp